export const getConsoleLog = ( keyData, valueData ) => {
  return console.log(keyData, valueData);
};
